var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.067C0 18.033 4.333 22.994 10 24v-8.667H7V12h3V9.333c0-3 1.933-4.666 4.667-4.666.866 0 1.8.133 2.666.266V8H15.8c-1.467 0-1.8.733-1.8 1.667V12h3.2l-.533 3.333H14V24c5.667-1.006 10-5.966 10-11.933C24 5.43 18.6 0 12 0S0 5.43 0 12.067z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDEyLjA2N0MwIDE4LjAzMyA0LjMzMyAyMi45OTQgMTAgMjR2LTguNjY3SDdWMTJoM1Y5LjMzM2MwLTMgMS45MzMtNC42NjYgNC42NjctNC42NjYuODY2IDAgMS44LjEzMyAyLjY2Ni4yNjZWOEgxNS44Yy0xLjQ2NyAwLTEuOC43MzMtMS44IDEuNjY3VjEyaDMuMmwtLjUzMyAzLjMzM0gxNFYyNGM1LjY2Ny0xLjAwNiAxMC01Ljk2NiAxMC0xMS45MzNDMjQgNS40MyAxOC42IDAgMTIgMFMwIDUuNDMgMCAxMi4wNjdaIiBmaWxsPSIjZmZmIi8+Cjwvc3ZnPg==";
export { ForwardRef as ReactComponent };